'use client';

import { useState, useEffect } from 'react';

/**
 * A hook that detects if the current device is mobile based on screen width
 * @param {number} breakpoint - The breakpoint in pixels to consider as mobile (default: 768)
 * @returns {boolean} - True if the device is mobile, false otherwise
 */
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Check on mount
    checkIsMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIsMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkIsMobile);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile; 